import React from 'react';
import { useSelector } from 'react-redux';
import CompletedMap from './completed/map';
import CancelledMap from './cancelled/map';
import ErrorMap from './error/map';
import { OrderMissionEntity, OrderStatusEnum } from '@src/features/order/entities';
import { selectSelectedHistoryOrder } from '@src/features/history/redux';

const Maps: React.FC = () => {
  const order = useSelector(selectSelectedHistoryOrder);

  if (!order) return null;

  switch (order.status) {
  case OrderStatusEnum.CANCELLED:
    return <CancelledMap order={order as OrderMissionEntity} />;
  case OrderStatusEnum.ERROR:
    return <ErrorMap order={order as OrderMissionEntity} />;
  default:
    return <CompletedMap order={order as OrderMissionEntity} />;
  }
};

export default Maps;
